export type UpgradePopupViewType = 'sidebar' | 'modal' | 'thank-you';
